import { useMediaQuery, useTheme, Stack } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { getMenuItems } from "./data";
import LeftPanel from "./LeftPanel";
import RightPanel from "./RightPanel";
import MobileMenu from "./MobileMenu";

interface IntroductionTourProps {
  onFinish?: () => void;
}

export default function IntroductionTour({ onFinish }: IntroductionTourProps) {
  const theme = useTheme();
  const { t } = useTranslation();
  const menuItems = getMenuItems(t);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeMenuItem, setActiveMenuItem] = useState(0);

  const handleNext = () => {
    if (activeMenuItem < menuItems.length - 1) {
      setActiveMenuItem(activeMenuItem + 1);
    }
  };

  const handleBack = () => {
    if (activeMenuItem > 0) {
      setActiveMenuItem(activeMenuItem - 1);
    }
  };

  const handleMenuItemClick = (index: number) => {
    setActiveMenuItem(index);
  };

  const handleMobileMenuToggle = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const currentItem = menuItems[activeMenuItem];

  return (
    <>
      {/* Main Container */}
      <Stack
        sx={{
          width: "100%",
          display: "flex",
          position: "relative",
          overflow: "hidden",
          flexDirection: { xs: "column", lg: "row" },
        }}
      >
        {!isSmallScreen && (
          <Stack
            sx={{
              width: { md: "280px", lg: "380px" },
              minWidth: "280px",
              borderRight: "1px solid",
              borderColor: "divider",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              flexShrink: 0,
              p: 3,
              minHeight: "100vh",
            }}
          >
            <LeftPanel
              menuItems={menuItems}
              activeMenuItem={activeMenuItem}
              onMenuItemClick={handleMenuItemClick}
              isSmallScreen={isSmallScreen}
            />
          </Stack>
        )}

        {/* Right Panel Content */}
        <Stack
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <RightPanel
            currentItem={currentItem}
            activeMenuItem={activeMenuItem}
            menuItemsLength={menuItems.length}
            onNext={handleNext}
            onBack={handleBack}
            onFinish={onFinish || (() => {})}
            onClose={onFinish}
            onMenuToggle={handleMobileMenuToggle}
            isSmallScreen={isSmallScreen}
          />
        </Stack>
      </Stack>

      {/* Mobile Menu Overlay - Small Screens Only */}
      <MobileMenu
        isOpen={isSmallScreen && mobileMenuOpen}
        menuItems={menuItems}
        activeMenuItem={activeMenuItem}
        onMenuItemClick={handleMenuItemClick}
        onClose={handleMobileMenuToggle}
      />
    </>
  );
}
